module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vcfpgO/tc-custom/9781398429512.jpg?1705056297887",
      "alt": "This image is the cover for the book Space Ranger Rob"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Space Ranger Rob\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("With the galaxy under threat from the evil Dark Master and his sinister plot to destroy the Sun, Earth makes the call to Space Ranger Rob."), _c('br'), _vm._v("Equipped with his rocket-powered skateboard and a backpack full of gadgets, this ranger has all the tools for an epic space adventure."), _c('br'), _vm._v("So prepare for ignition in 5…4…3…2…1")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Cross\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("From the wrestling ring, to the writing desk, Stephen Cross grew up in Birmingham, England, always showing a passion for entertaining an audience in one way or another. Now join Stephen as he embarks on his mission, going from creating visual stories in the world of pro wrestling, to capturing imagination in the world of story writing. Prepare for Lift off in his first space adventure.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0